<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item" aria-current="page">
                <router-link to="/stock/stockouts">{{$t('stock_out_list')}}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">[{{stockin.Num}}]</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <router-link v-if="!stockin.IsApproved" :to="{ name: 'stock_out_update', params: { id: $route.params.id }}" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-pencil"></i> {{$t('edit')}}</router-link>
            <button v-if="!stockin.IsApproved" type="button" class="btn btn-outline-primary btn-sm no-bor" @click="approveClick"><i class="fa fa-check"></i> {{ $t('approval') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="printClick"><i class="fa fa-print"></i> {{ $t('print') }}</button>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <div>
                                    <select class="form-control form-control-sm" v-model="printType">
                                        <option value="1">NONE TAX INVOICE</option>
                                        <option value="2">TAX INVOICE</option>
                                        <option value="3">VEGETABLE INVOICE</option>
                                        <option value="4">FRUIT INVOICE</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <table class="table-print">
                                <tbody>
                                    <tr>
                                        <td style="width: 120px;">{{ $t('branch_name') }}</td>
                                        <td style="width: 15px;">:</td>
                                        <td>{{branch.Name}}</td>
                                    </tr>
                                    <tr>
                                        <td>Stock Supervisor</td>
                                        <td>:</td>
                                        <td>{{employee.KhmerName}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-sm-6">
                            <table class="table-print" align="right">
                                <tbody>
                                    <tr>
                                        <td style="width: 100px;">Delivery No</td>
                                        <td style="width: 15px;">:</td>
                                        <td style="min-width: 150px;">{{stockin.Num}}</td>
                                    </tr>
                                    <tr>
                                        <td>Delivery Date</td>
                                        <td>:</td>
                                        <td>{{$format(stockin.OutDateAt, 'DD/MM/YYYY')}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-sm table-grid no-bor">
                                <thead>
                                    <tr class="toUpper">
                                        <th>{{$t('no')}}</th>
                                        <th>{{$t('item_code')}}</th>
                                        <th>{{$t('item_name')}}</th>
                                        <th>{{$t('description')}}</th>
                                        <th style="width: 120px;" class="text-center">{{$t('qty')}}</th>
                                        <th style="width: 120px;">{{$t('uom')}}</th>
                                        <th style="width: 120px;" class="text-center">{{$t('total_damage')}}</th>
                                        <th style="width: 120px;" class="text-center">{{$t('total_received')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret, index) in lines" :key="index">
                                        <td>{{index + 1}}</td>
                                        <td>{{ret.ItemCode}}</td>
                                        <td>{{ret.ItemName}}</td>
                                        <td>{{ret.Description}}</td>
                                        <td class="text-center">{{ret.QuantityOut}}</td>
                                        <td>{{ret.UomName}}</td>
                                        <td class="cell-input"><input type="number" class="form-control form-control-sm" v-model="ret.QtyDamaged" @blur="onDamageChange(ret)" :disabled="stockin.IsApproved" /></td>
                                        <td class="text-center">{{ret.QtyReceived}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                branch: {},
                stockin: {},
                employee: {
                    KhmerName: ''
                },
                lines: [],
                printType: 1
            }
        },
        created(){
            var id = this.$route.params.id;
            if(id != undefined && id != null && id != ''){
                this.findById(id);
            }
        },
        methods: {
            findById(id){
                var loading = this.$loading.show();
                this.$api().post('stockout/find', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        var data = res.data.Data;
                        this.stockin = data.StockOut;
                        this.branch = data.Branch;
                        if(data.Employee != null)
                            this.employee = data.Employee;
                        this.lines = data.StockOutLines;
                    }
                }).finally(function() { loading.hide(); });
            },
            approveClick(){
                var loading = this.$loading.show();
                this.$api().post('stockout/approve', { Id: this.$route.params.id }).then(res => {
                    if(this.$isValid(res)){
                        this.$router.push('/stockout');
                    }
                }).finally(function() { loading.hide(); });
            },
            printClick(){
                window.open('/print/stockout/' + this.$route.params.id + '?type=' + this.printType, '_blank');
            },
            onDamageChange(item){
                if(item.QuantityOut >= item.QtyDamaged){
                    item.QtyReceived = item.QuantityOut - item.QtyDamaged;
                }else{
                    item.QtyReceived = 0;
                    item.QtyDamaged = item.QuantityOut;
                }
                var loading = this.$loading.show();
                this.$api().post('update-delivery-received', item).then(res => {
                    this.$isValid(res);
                }).finally(function() { loading.hide(); });
            }
        }
    }
</script>
<style scoped>
    .table-print thead tr th,
    .table-print tbody tr td{
        padding: 5px 0;
    }
</style>